export default class Accordion {
    constructor()
    {
        $(document).on('click', '.block-accordion__item-title', function() {
            $(this).parent().toggleClass('block-accordion__item--open');
        });
    }
}